(function() {

	var apiKey = '';

	var observer;

	var activatedMaps = [];

	function initPage(key) {

		apiKey = key;

		if (!observer) {

			observer = new IntersectionObserver(
				function(entries) {
					entries.forEach(function(entry) {
						if (entry.isIntersecting) {
							initMap(entry.target);
							observer.unobserve(entry.target);
						}
					});
				},
				{
					threshold: 0.2
				}
			);

		}

		$('.branch-google-map').each(function() {
			observer.observe(this);
		});


	}

	function loadGoogleMapsSdkIfNeeded() {
		if (!window['google'] || !google.maps) {
			var s = document.createElement('script');
			s.async = true;
			s.defer = true;
			s.src = 'https://maps.googleapis.com/maps/api/js?loading=async&callback=initAllVisibleMapsOnBranchesPage&key=' + apiKey;
			document.head.appendChild(s);	
		}	
	}

	function initMap(mapContainer) {
		activatedMaps.push(mapContainer);
		loadGoogleMapsSdkIfNeeded();
		initActivatedMaps();
	}

	function initActivatedMaps() {
		if (window['google'] && google.maps) {
			activatedMaps.forEach(function(map) {
				initOneMapNow(map);
			});
			activatedMaps = [];
		}
	}

	function initOneMapNow(mapContainer) {

		try {
			var pos = JSON.parse($(mapContainer).attr("data-marker-position"))
		} catch (e) {
			return;
		}

		var googleMap = new google.maps.Map(
			mapContainer, {
				zoom: 15,
				center: pos,
				scrollwheel: false
			}
		);

		var marker = new google.maps.Marker({
			position: pos,
			icon: "imgs/map-marker.png"
		});

		marker.setMap(googleMap);


	}

	window.initBranchesPageMaps = initPage;
	window.initAllVisibleMapsOnBranchesPage = initActivatedMaps;

})();
